import { useEffect, useState } from "react";
import Hub from "../../../../api/Hub";
import Div from "../../../../components/base/Div";
import Indicator from "../../../../components/base/Indicator";
import { toastSuccess } from "../../../../components/base/Toast";
import { DrawerForm } from "../../../../components/drawers/DrawerForm";
import TextBox from "../../../../components/form/TextBox";
import PhoneInput from "../../../../components/form/PhoneInput";
import FormTitle from "../../../../components/form/FormTitle";
import { API_ROUTES } from "../../../../core/Constants";
import WaInstance from "../models/WaInstance";


interface IProps {
    // Undefined means create; otherwise the instance being edited.
    instanceId?: string
    onClose?: () => void
    onSave?: () => void
}

export default function WaInstanceForm(props: IProps) {

    const hub = new Hub<WaInstance>(API_ROUTES.WaInstances);

    const [loading, loadingSet] = useState<boolean>(!!props.instanceId);
    const [model, modelSet] = useState<WaInstance>();

    const isUpdate = !!props.instanceId;

    useEffect(() => {
        if (!props.instanceId) return;
        loadingSet(true);
        hub.Find(props.instanceId, res => {
            if (res.success) modelSet(res.data);
            loadingSet(false);
        });
    }, [props.instanceId]);

    return (
        <DrawerForm id="drawer-wa-instance"
            title={isUpdate ? "Edit WhatsApp Instance" : "Add WhatsApp Instance"}
            titleIcon="whatsapp"
            size="large"
            buttonText={isUpdate ? "Save Instance" : "Create Instance"}
            focusOn={loading ? undefined : "name"}
            hideButtons={loading}
            onClose={props.onClose}
            onSubmitted={props.onSave}
            onSubmit={(body, callback) => {

                if (isUpdate) {
                    hub.Update(props.instanceId ?? "", body, res => {
                        if (res.success) toastSuccess("Instance has been updated successfully!");
                        callback!(res);
                    });
                }
                else {
                    hub.Create(body, res => {
                        if (res.success) toastSuccess("Instance has been created successfully!");
                        callback!(res);
                    });
                }

            }}>

            <Div visible={loading} className="p-20 text-center">
                <Indicator text="Please wait..." />
            </Div>

            {
                // The fields are uncontrolled (defaultValue), so they must not mount before the
                // instance is fetched -- otherwise they would stay empty on edit.
                !loading &&
                <>
                    <FormTitle title="Instance" />
                    <TextBox name="name" label="Name" placeholder="Rinvox Backup" defaultValue={model?.name} autoFocus />
                    {/* The same input the profile uses for a technician's WhatsApp number --
                        countryCodes="all" because a gateway number is not necessarily US. */}
                    <PhoneInput name="phone" label="Phone Number"
                        countryCodes="all" defaultPhone={model?.phone} />

                    <FormTitle title="Green API" />
                    <TextBox name="apiUrl" label="Api Url" placeholder="https://7105.api.greenapi.com" defaultValue={model?.apiUrl} />
                    <TextBox name="mediaUrl" label="Media Url" placeholder="https://7105.media.greenapi.com" defaultValue={model?.mediaUrl} />
                    <TextBox name="idInstance" label="Instance Id" placeholder="710522700140" numeric maxLength={20} defaultValue={model?.idInstance} />
                    <TextBox name="apiTokenInstance" label="Api Token" defaultValue={model?.apiTokenInstance} />
                </>
            }

        </DrawerForm>
    )
}
